
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as OfferParametersModels from '../../models/tyre-offer-parameters/tyre-offer-parameters';
import { EnvironmentService } from '../../../app/services/environment.service';

@Injectable({
  providedIn: 'root'
})

export class TyreOfferParametersService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public set(OfferParameters: OfferParametersModels.TyreOfferParameterModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };

    return this.httpClient.post<HttpEventType>(`${this.environmentService.getApiURL()}/tyre-offer/parameters/set`, OfferParameters, options);
  }

  public get() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };

    return this.httpClient.post<OfferParametersModels.TyreOfferParameterListModel>(`${this.environmentService.getApiURL()}/tyre-offer/parameters/get`, options);
  }
}
